import React, { useState, useMemo, useEffect } from 'react'
import { Button, Modal, Upload, message, Form, DatePicker } from 'antd'
import { updateApplicationDeliveryDate } from '../../../services/application'

const DeliveryDateModal = ({ application, showModal, onSuccess, onChancel }) => {
  const [form] = Form.useForm()

  useEffect(() => {
    form.setFieldsValue({})
  }, [application?.id])

  const clear = () => form.resetFields()

  const onCancelCallback = () => {
    onChancel()
    clear()
  }

  const onFinishCallback = (data) => {
    updateApplicationDeliveryDate(application?.id, {
      data: {
        deliveryDate: data.date,
      },
    })
      .then(() => {
        onSuccess()
        message.success('Дата приемки успешно обновлена')
      })
      .catch(() => {
        message.error('Ошибка обновления даты приемки')
      })
      .finally(() => {
        onCancelCallback()
      })
  }

  return (
    <Modal
      title="Дата приемки"
      visible={showModal}
      onCancel={onCancelCallback}
      footer={[
        <Button key="back" onClick={() => form.submit()}>
          Сохранить
        </Button>,
      ]}
    >
      <Form
        name="app-payment"
        onFinish={onFinishCallback}
        autoComplete="off"
        layout="horizontal"
        form={form}
        size="large"
      >
        <Form.Item name="date" label="Дата" labelCol={{ span: 24 }}>
          <DatePicker placeholder="Дата приемки" format="DD.MM.YYYY" />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default DeliveryDateModal
